import { cx } from '@trinity/chat-components/utils';
import styles from './style/PopperWrapper.module.css';

type Props = {
  className?: string;
  children: React.ReactNode;
};

export const PopperWrapper = (props: Props) => {
  return (
    <div className={cx(styles.popper, props.className)}>
      {props.children}
    </div>
  );
};